export const extractInitialsFromWords = (words: string): string => {
    const wordsArray = words.split(" ");
    const initialsArray = wordsArray.map((word) => word?.[0]?.toUpperCase());
    return initialsArray.join("");
};
